// src/pages/CheckoutSuccess.js
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import successGif from "./success.gif"; // Add a nice success animation


const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
//   const [status, setStatus] = useState("Verifying payment...");
  const [status, setStatus] = useState("Payment Successful! 🎉");
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  console.log("searchParams", searchParams)

  useEffect(() => {
    const txnid = searchParams.get("txnid");
    if (txnid) {
      fetch("https://api.glocart.in/payment/api/verify-payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ txnid }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setIsSuccess(true);
            setStatus("Your payment was successful! 🎉");
          } else {
            setIsSuccess(false);
            setStatus("Payment failed. Please try again.");
          }
        })
        .catch(() => {
          setStatus("Something went wrong while verifying payment.");
        });
    }
  }, []);

  return (
    <div style={styles.container}>
      {/* Header */}
      {/* <header style={styles.header}>
        <img src={logo} alt="Shreenath Foods" style={styles.logo} />
        <h1 style={styles.title}>Shreenath Foods</h1>
      </header> */}

      {/* Content */}
      <div style={styles.content}>
        <img
          src={successGif}
          alt="Success Animation"
          style={{ width: "180px", marginBottom: "30px" }}
        />
        <h2 style={{ fontSize: "28px", color: isSuccess ? "#2d6a4f" : "#c1121f" }}>
          {status}
        </h2>
        <p style={styles.subtitle}>
          {isSuccess
            ? "Thank you for your order! We'll start preparing it shortly."
            : "Your transaction could not be completed."}
        </p>

        <button
          style={styles.button}
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default CheckoutSuccess;

const styles = {
  container: {
    fontFamily: "'Poppins', sans-serif",
    minHeight: "100vh",
    background: "linear-gradient(145deg, #fffdf7, #f9f3ea)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
       justifyContent:'center',
    paddingTop: "50px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: "40px",
  },
  logo: {
    height: "60px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "#a6141e",
  },
  content: {
    textAlign: "center",
    background: "#fff",
    padding: "40px 30px",
    borderRadius: "16px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    maxWidth: "600px",
    width: "90%",
  },
  subtitle: {
    fontSize: "16px",
    color: "#555",
    margin: "20px 0",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "bold",
    background: "#a6141e",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s",
  },
};
